var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMarkAsUnreadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "20px",
    viewBox: "0 -960 960 960",
    width: "20px",
    fill: "#6b727e",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168-192q-29.7 0-50.85-21.16Q96-234.32 96-264.04v-432.24Q96-726 117.15-747T168-768h385q-2 17-1 35.5t6 36.5H168l312 179 140-81q14 13 37 24t41 16L480-432 168-611v347h624v-294.46q20-4.54 37.5-14.04T864-594v329.77Q864-234 842.5-213 821-192 792-192H168Zm0-504v432-432Zm576 72q-50 0-85-35t-35-85q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkAsUnreadIcon);
export default __webpack_public_path__ + "static/media/mark_as_unread_icon.1848a49d981f6f2d61103f009f6a92a1.svg";
export { ForwardRef as ReactComponent };